module.exports = __webpack_public_path__ + "static/media/postcard5.8ba779d2.jpg";